import styled from 'styled-components';
export const RightAlignedTD = styled.td.withConfig({
  displayName: "RightAlignedTD",
  componentId: "sc-1rpcqlt-0"
})(["text-align:right;"]);